import { MuiTelInputInfo } from "mui-tel-input";

export function preparePhoneForPost(phone: string | MuiTelInputInfo) {
  if (typeof phone === "string") {
    return phone.replace(/[\s+]+/g, "");
  }
  if (!phone.nationalNumber) {
    return "";
  }

  return phone.numberValue?.replace(/[\s+]+/g, "") || "";
}

export function preparePhoneForFormValues(phone: string | undefined | null) {
  if (!phone) {
    return "";
  }

  return `+ ${phone}`;
}

export function preparePhoneForView(phone: string | undefined | null) {
  if (!phone) {
    return "-";
  }

  return `+ ${phone}`;
}
